import { ApolloError } from 'apollo-client'
import * as React from 'react'
import { Mutation, MutationFunction } from 'react-apollo'

import { NativeLink } from 'main/ui'
import {
  FORGOT_PASSWORD_MUTATION,
  ForgotPassword as ForgotPasswordData,
  ForgotPasswordVariables,
} from './gql'

interface IProps {
  email: string
  onChangeValidationHint: (validationHint: string) => void
  onComplete: () => void
  onError: () => void
}

function ForgotPassword(props: IProps) {
  const { onComplete } = props

  return (
    <Mutation<ForgotPasswordData, ForgotPasswordVariables>
      mutation={FORGOT_PASSWORD_MUTATION}
      onCompleted={() => onComplete()}
      onError={error => handleError(props, error)}
    >
      {(mutate, { loading }) => (
        <NativeLink onClick={() => handleClick(props, mutate)}>
          {loading ? 'Submitting...' : 'Forgot your password?'}
        </NativeLink>
      )}
    </Mutation>
  )
}

function handleClick(
  props: IProps,
  mutate: MutationFunction<ForgotPasswordData, ForgotPasswordVariables>,
) {
  const { email, onChangeValidationHint } = props

  if (!email) {
    return onChangeValidationHint('Please enter an email')
  }

  mutate({
    variables: {
      destination: window.location.href,
      email: email.trim(),
    },
  })
}

function handleError(props: IProps, error: ApolloError) {
  const { onChangeValidationHint, onError } = props
  const firstError = error.graphQLErrors[0]

  switch (firstError && firstError.message) {
    case 'user_not_found':
      return onChangeValidationHint('Email was not found')
    default:
      return onError()
  }
}

export default React.memo(ForgotPassword)
